import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {getFieldValue} from "./contractsFieldsFunctions";
import ContractsContext from "./contractsContext";
import {setContractsValues} from "../../../actions/contractsActions";
import {setFinancePaymentType} from "../../../actions/priceWorksheetActions";

const ContractsPopupCheckboxField = (props) => {

  const {fieldIndex, fieldName, fieldCoords, setContractsValues, contractsValues, setFinancePaymentType} = props;

  const {activeContract, activeContractPage} = useContext(ContractsContext);

  const fieldValue = getFieldValue(activeContractPage, fieldIndex, activeContract, contractsValues);
  const style = {
    left: fieldCoords.left,
    top: fieldCoords.top + 2
  }

  const setCheckboxValue = (value, pageIndex = activeContractPage, fIndex = fieldIndex, name = fieldName) => {
    setContractsValues({
      contractId: activeContract.id,
      pageIndex,
      fieldIndex: fIndex,
      name,
      value,
    });
  }

  const onCheckClick = () => {
    if ((fieldName === "checkAch") || (fieldName === "creditCard")) { // this is toggle (radio), so we need update every checkbox
      setFinancePaymentType(fieldName);
      activeContract.fields.forEach(field => {
        if ((field.name === "checkAch") || (field.name === "creditCard")) {
          field.coords?.forEach((coord) => {
            setCheckboxValue(field.name === fieldName, coord.page, coord.fieldIndexOnPage, field.name);
          });
        }
      });
    } else {
      setCheckboxValue(!fieldValue);
    }
  }

  return (
    <div className={'contract-body__custom-field contract-body__custom-field-checkbox u-p-0'}
         key={`checkbox_${fieldIndex}`}
         style={style}
         id={"field" + fieldIndex}
         onClick={onCheckClick}>
      {fieldValue ? (
        <Fragment>
          <div className="contract-body__custom-field-checkbox-checked-1" />
          <div className="contract-body__custom-field-checkbox-checked-2" />
        </Fragment>
      ) : null}
    </div>
  )
};

ContractsPopupCheckboxField.propTypes = {
  fieldIndex: PropTypes.number.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldCoords: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  const {contractsValues} = store.contractSigningState;
  return {
    contractsValues,
  };
};

const mapDispathToProps = {
  setContractsValues,
  setFinancePaymentType,
}

export default connect(mapStateToProps, mapDispathToProps)(ContractsPopupCheckboxField)
